



























































































import Vue from "vue";
import Page from "@/components/Page.vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, {PartnerPayDateStore} from "../services/PartnerPayDateStore";
import { t } from "@/plugins/i18n";

interface Data {
    loading: boolean;
    store: PartnerPayDateStore;
    eventBus: any;
}

interface Methods {
    create(): void;
    edit(id: number): void;
    remove(id: number): void;
    getPayCountTypeName(countType: number): string;
    getPayModeName(payMode: number): string;
    getPayDayTypeName(payDay: number): string;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        Page,
        IconButton
    },

    async beforeMount() {
        this.loading = true;
        await store.loadPayCountTypes();
        await store.loadPayModes();
        await store.loadPayDayTypes();
        this.loading = false;
    },

    data() {
        return {
            loading: false,
            eventBus,
            store
        };
    },

    methods: {
        create(): void {
            this.$router.push('/partner-paydate/paydate/create');
        },
        edit(id: number): void {
            this.$router.push(`/partner-paydate/paydate/edit/${id}`);
        },
        remove(id: number): void {
            store.removePartnerPayDate(id).then(r => eventBus.$emit('refreshPartnerPayDays'));
        },
        getPayCountTypeName(payCountType: number): string {
            return store.payCountTypes.find((x) => x.id == payCountType)?.name ?? "";
        },
        getPayModeName(payMode: number): string {
            return store.payModes.find((x) => x.id == payMode)?.name ?? "";
        },
        getPayDayTypeName(payDay: number): string {
            return store.payDayTypes.find((x) => x.id == payDay)?.name ?? "";
        },
    },

    computed: {
        url() {
            return `partner-paydate/paydates/search`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    headerClass: "detailsColumn",
                    filterable: false,
                    sortable: false
                },
                {
                    field: "id",
                    title: "ID",  
                    filterable: false, 
                    sortable: false ,
                    type: ColumnType.Right
                },
                {
                    field: "name",
                    title: t("Nev")
                },
                {
                    field: "note",
                    title: t("Leiras")
                },
                { //TODO: Multiselect?
                    field: "isCustomer",
                    title: t("PartnerPayDate_Vevoi"),
                    cell: "isCustomer",
                    type: ColumnType.Center
                },
                { //TODO: Multiselect?
                    field: "isSupplier",
                    title: t("PartnerPayDate_Szallitoi"),
                    cell: "isSupplier",
                    type: ColumnType.Center
                },
                {
                    title: t("FizetesiMod"),
                    field: "paymentMode",
                    cell: "paymentMode",
                    multiselect: true,
                    multiselectField: "selectedPayModes",
                    multiselectOptions: store.payModes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                { 
                    field: "startDate",
                    title: t("PartnerPayDate_ErvenyessegKezdete"),
                    type: ColumnType.Date
                },
                {
                    field: "countType",
                    title: t("PartnerPayDate_HonnanKellSzamolni"),
                    cell: "countType",
                    multiselect: true,
                    multiselectField: "selectedPayCountTypes",
                    multiselectOptions: store.payCountTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                {
                    field: "payTerm",
                    title: t("FizetesiHatarido"),
                    type: ColumnType.Right
                },
                { 
                    field: "dayType",
                    title: t("PartnerPayDate_MilyenNapokraVonatkozik"),
                    cell: "dayType",
                    multiselect: true,
                    multiselectField: "selectedPayDayTypes",
                    multiselectOptions: store.payDayTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    }))
                },
                {
                    field: "day",
                    title: t("PartnerPayDate_HanyadikNap"),
                    type: ColumnType.Right
                },
                {
                    field: "customerAccCode",
                    title: t("PartnerPayDate_VevoiSkontoFokonyviSzam"),
                    type: ColumnType.Right
                },
                {
                    field: "supplierlAccCode",
                    title: t("PartnerPayDate_SzallitoiSkontoFokonyviSzam"),
                    type: ColumnType.Right
                },
                {
                    field: "skontoDays",
                    title: t("PartnerPayDate_SkontoNapokSzama"),
                    type: ColumnType.Right
                },
                {
                    field: "skontoPercent",
                    title: t("PartnerPayDate_Skonto_2"),
                    type: ColumnType.Right
                },
            ];
        },
    },
});
